export class Configurations {
    EH_FQDN: string;
    EH_CONNECTION_STRING: string;
    CamundaRestApiUri: string;
    LogitudeApiUri: string;
}